import script from "./AboutEyuanPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutEyuanPage.vue?vue&type=script&setup=true&lang=js"

import "./AboutEyuanPage.vue?vue&type=style&index=0&id=0418a30c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0418a30c"]])

export default __exports__